import {
    createRouter,
    createWebHashHistory
} from 'vue-router'
import store from '@/store'
import FingerprintJS from '@fingerprintjs/fingerprintjs';
const routes = [{
        path: '/Upload',
        name: 'Upload',
        component: () =>
            import('../views/Upload.vue')
    },
    {
        path: '/MessageNotice',
        name: 'MessageNotice',
        component: () =>
            import('../views/MessageNotice.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: () =>
            import('../views/404.vue')
    },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

//定义变量判断是否已经动态添加过,如果刷新后load永远为 0
let load = 0
//这是一个导航守卫
router.beforeEach(async (to, form, next) => {
    const tokenStr = window.localStorage.getItem('token')
    const fingerprint = window.localStorage.getItem('fingerprint')
    if (!fingerprint) {
        try {
            const fp = await FingerprintJS.load();
            const result = await fp.get();
            window.localStorage.setItem('fingerprint', result.visitorId)
        } catch (error) {
            console.error('加载指纹生成器时出错:', error);
        }
    }

    // 根路径与历史登录路由(/Login)统一整页转发独立登录页:已登录时由 login.html 已登录分支
    // 自动跳首个可访问页面;不携带 redirect,防止登录成功后回跳 #/ 或 #/Login 死循环
    if (to.path === '/' || to.path === '/Login') {
        window.location.replace('/login')
        return
    }
    // 未登录访问:整页跳独立登录页 /login,目标地址放 redirect 参数,登录成功后跳回
    if (!tokenStr) {
        window.location.replace('/login?redirect=' + encodeURIComponent(to.fullPath))
        return
    }
    // 路由缓存
    // 设置表头高度
    store.dispatch('SETHIDE', 62)
    store.dispatch('SETURI', to)
    if (load === 0) {
        const route = JSON.parse(window.localStorage.getItem('route'))
        const jurisdiction = JSON.parse(window.localStorage.getItem('jurisdiction'))
        load++
        // 初始化全局日期
        store.dispatch('SETODAY')
        // 全局路由
        // 全局用户名
        store.dispatch('SETUNAME', jurisdiction.realname)

        store.dispatch('SETAKEY', jurisdiction.post)
        // 全局路由表
        store.dispatch('SETROUTE', route)
        // 加载路由表
        await addData(route)
        await next(to.fullPath)
    } else {
        next()
    }

})


//动态添加路由方法
export function addData(route) {
    route.forEach(item => {
        router.addRoute({
            path: '/' + item.path,
            name: item.path,
            component: () => import(`../views/${item.path}.vue`),
        })
        if (item.tabsName.length) {
            store.dispatch('SETABS', {
                key: '/' + item.path,
                vl: item.tabsName
            })
        }
    })
    return router
}




export default router